import React from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';

const ServiziTab = ({ services }) => {
  return (
    <div className="space-y-4 md:space-y-6">
      {services?.length > 0 ? (
        services?.map((service) => (
          <div
            key={service?.id}
            className="bg-card rounded-lg md:rounded-xl p-4 md:p-6 lg:p-8 shadow-warm"
          >
            <div className="flex flex-col lg:flex-row gap-4 md:gap-6">
              <div className="w-16 h-16 md:w-20 md:h-20 rounded-lg bg-primary/10 flex items-center justify-center flex-shrink-0">
                <Icon name={service?.icon} size={32} color="var(--color-primary)" />
              </div>

              <div className="flex-1 min-w-0">
                <div className="flex flex-col md:flex-row md:items-start md:justify-between gap-3 mb-3">
                  <div className="flex-1 min-w-0">
                    <h3 className="text-lg md:text-xl lg:text-2xl font-heading font-bold text-foreground mb-2">
                      {service?.name}
                    </h3>
                    <p className="text-sm md:text-base text-muted-foreground line-clamp-2">
                      {service?.description}
                    </p>
                  </div>

                  <div className="flex items-center gap-2">
                    <span className="text-2xl md:text-3xl font-heading font-bold text-primary whitespace-nowrap">
                      €{service?.price?.toFixed(2)}
                    </span>
                  </div>
                </div>

                <div className="space-y-2 mb-4">
                  <div className="flex items-center gap-2 text-sm text-muted-foreground">
                    <Icon name="Clock" size={16} />
                    <span>Durata: {service?.duration}</span>
                  </div>
                  {service?.availability && (
                    <div className="flex items-center gap-2 text-sm text-success">
                      <Icon name="Calendar" size={16} />
                      <span>{service?.availability}</span>
                    </div>
                  )}
                </div>

                {service?.features && service?.features?.length > 0 && (
                  <div className="mb-4">
                    <p className="text-sm font-caption font-semibold text-foreground mb-2">
                      Include:
                    </p>
                    <ul className="space-y-1.5">
                      {service?.features?.map((feature, index) => (
                        <li key={index} className="flex items-start gap-2 text-sm text-muted-foreground">
                          <Icon name="Check" size={16} className="text-success flex-shrink-0 mt-0.5" />
                          <span>{feature}</span>
                        </li>
                      ))}
                    </ul>
                  </div>
                )}

                <Button
                  variant="default"
                  size="default"
                  iconName="Calendar"
                  iconPosition="left"
                  className="w-full md:w-auto"
                >
                  Prenota Servizio
                </Button>
              </div>
            </div>
          </div>
        ))
      ) : (
        <div className="bg-card rounded-lg md:rounded-xl lg:rounded-2xl p-8 md:p-12 text-center shadow-warm">
          <div className="w-16 h-16 md:w-20 md:h-20 rounded-full bg-muted mx-auto mb-4 flex items-center justify-center">
            <Icon name="Wrench" size={32} className="text-muted-foreground" />
          </div>
          <h3 className="text-lg md:text-xl font-heading font-bold text-foreground mb-2">
            Nessun Servizio Disponibile
          </h3>
          <p className="text-sm md:text-base text-muted-foreground">
            Al momento non ci sono servizi offerti da questa attività.
          </p>
        </div>
      )}
    </div>
  );
};

export default ServiziTab;